"use strict";
(function(){

  angular.module('irricrops')

      .controller('vinedoMapaCtrl', ['$q', '$scope', '$state', '$stateParams',
        'CONSTANTES', 'gma','uiGmapIsReady','mapFactory','$timeout','mapaVinedo',
        'global','sectoresData', 'cuartelesData', 'scholanderData', 'sensoresData','menu', 'cuartelDialog',
        function($q, $scope, $state, $stateParams,
                 CONSTANTES, gma, ready,mapFactory, $timeout, mapaVinedo,
                 global, sectoresData, cuartelesData, scholanderData, sensoresData, menu, cuartelDialog){


          var vm                = this;
          var colors            = mapFactory.getColors();
          vm.sectoresSensor     = sensoresData.data.sectores;
          vm.sectoresScholander = scholanderData.data;
          vm.min                = 40;
          vm.max                = 60;
          vm.actualLayer        = 'sector';
          vm.mapaVinedo         = mapaVinedo;
          vm.windowInfo         = {
            marker  : {
              id : 1234
            },
            options : {
              visible : false
            },
            scope   : {}
          };



          $(window).resize(function(){
            var a = $(".angular-google-map-container");
            if (global.responsiveIs("xs") || global.responsiveIs("sm")) {
              a.css("width", ($(document).width())+"px");
              a.css("min-width", ($(document).width())+"px");
            }else{
              a.css("height", ($(document).height()-50)+"px");
              a.css("min-height", ($(document).height()-50)+"px");
            }
          });







          _.each(vm.sectoresSensor, function(sectorSensor){
            var alturas = [];
            sectorSensor.sensores = [];
            _.each(sectorSensor.datos, function(datos, ind){
              if(ind == 0 && datos[0]=="fecha"){
                alturas = datos;
                _.each(alturas, function(alt, indAlt){
                  if(indAlt == 0) return;
                  sectorSensor.sensores.push({
                    altura : alt,
                    datos:[],
                  });
                })
              }else{
                var fecha = 0;
                _.each(datos, function(dato, indDato){
                  if(indDato == 0){
                    fecha = dato;
                  }else{
                    _.each(sectorSensor.sensores, function(sensor, indSensor){
                      if(sensor.altura == alturas[indDato]){
                        sensor.datos.push({
                          cantidad: dato,
                          fecha: fecha
                        });
                      }
                    });
                  }
                })
              }
            });
          });


          _.each(vm.sectoresSensor, function(sectorSensor){
            //Define color y valores seleccionados segun fechaReferencia y profundidadReferencia
            _.each(sectorSensor.sensores, function(sensor, ind){
              //if(sectorSensor.sensor_ref == sensor.id){
              if(sensor.altura == sectorSensor.sensor_ref){
                sectorSensor.profundidadReferencia = sensor.altura;
                sectorSensor.sensorSelected        = sensor;
                if(sensor.datos.length > 0){
                  sectorSensor.datoSelected = sensor.datos[sensor.datos.length - 1];
                }
              }
              if(sensor.datos.length > 0){
                sensor.datoReferencia     = sensor.datos[sensor.datos.length - 1];
              }
            });
          });





          vm.showDialogSectorRiego = function ($event, sectorRiegoId) {
            cuartelDialog.showDialog($event, sectorRiegoId);
          }

          /**
           * @ngdoc method
           * @name google.maps.Data.Feature.prototype.getCenterMass
           * @methodOf google.maps.Data.Feature.prototype
           * @description
           * llamando a esta funcion, se puede obtener el centro de masa de un
           * poligono
           *
           * @returns {object}  con latitude y longitude
           */
          google.maps.Data.Feature.prototype.getCenterMass = function(){
            var f;
            var j;
            var nPts;
            var x      = 0;
            var y      = 0;
            var coords = Array();
            angular.forEach(this.getGeometry().getArray(), function(e) {
              angular.forEach(e, function(i) {
                nPts = i.length;
                j = nPts - 1;
                var area = 0;
                for (var n = 0; n < nPts; j = n++) {
                  var pt1 = i[n];
                  var pt2 = i[j];
                  f       = pt1.lat() * pt2.lng() - pt2.lat() * pt1.lng();
                  x      += (pt1.lat() + pt2.lat()) * f;
                  y      += (pt1.lng() + pt2.lng()) * f;
                  area   += pt1.lat() * pt2.lng();
                  area   -= pt1.lng() * pt2.lat();
                  coords.push({
                    lat: pt1.lat(),
                    lng: pt1.lng()
                  });
                }
                area /= 2;
                f = area * 6;
              });
            });
            return {
              latitude  : x / f,
              longitude : y / f,
            };
          }; //END get center mass




          var equipoColores   = [];
          var cuartelColores  = [];
          var sectorColores   = [];
          //var sensoresColores = [];

          /**
           * @ngdoc method
           * @name definirColores
           * @methodOf irricrops.vinedoMapaCtrl
           * @description
           * Define los colores en cuartelColores, segun id de sector de riego
           */
          var definirColores = function(){
            // dataSidebar = global.sidebar;
            var vinaActual = null;
            if (angular.isUndefined(global.sidebar)) {
              return false;
            }
            angular.forEach(global.sidebar.vinas, function(vina) {
              angular.forEach(vina.vinedos, function(vinedo) {
                if (vinedo.id == $stateParams.id) {
                  vinaActual = vina;
                }
              });
            });
            if (vinaActual === null) {
              return false;
            }

            var i = 0;
            angular.forEach(vinaActual.vinedos, function(vinedo){
              angular.forEach(vinedo.cuarteles, function(cuartel, indexCuartel){
                i = indexCuartel;
                while (i >= colors.length) {
                  i -= colors.length;
                }
                cuartelColores[cuartel.id] = colors[i];
              });
              angular.forEach(vinedo.equipos, function(equipo, indexEquipo){
                i = indexEquipo;
                while (i >= colors.length) {
                  i -= colors.length;
                }
                var color = colors[i];
                equipoColores[equipo.id] = color;
                angular.forEach(equipo.sectores_riego, function(sector){
                  sectorColores[sector.id] = color;
                });
              });
            });
          };


          var getColorCuartel = function(idCuartel){
            if(angular.isDefined(cuartelColores[idCuartel])){
              return cuartelColores[idCuartel];
            }
            return {background:"#FFFFFF", border: "#FFFFFF"};
          };

          var getColorEquipo = function(idEquipo){
            if(angular.isDefined(equipoColores[idEquipo])){
              return equipoColores[idEquipo];
            }
            return {background:"#FFFFFF", border: "#FFFFFF"};
          };

          var getColorSector = function(idSector){
            if(angular.isDefined(sectorColores[idSector])){
              return sectorColores[idSector];
            }
            return {background:"#FFFFFF", border: "#FFFFFF"};
          };

          var getColorSensor = function(num, min, max){
            var b = mapFactory.rgbify(num, min, max, true);
            return {
              background : b,
              border     : mapFactory.shadeRGBColor(b, -0.6),
              color      : mapFactory.shadeRGBColor(b, -0.3)
            }
          };

          //TODO testing, talves esta al revez la relacion de colores
          var getColorScholander = function(num, max){
            if(max == 0){
              b = "rgba(63,81,181,1)"; //indigo 500
            }else{
              var b = mapFactory.rgbify(num, max - 3 , max, false); //3 porque es inclusivo, si es menor o igual al segundo parametro se considera bajo
            }
            return {
              background : b,
              border     : mapFactory.shadeRGBColor(b, -0.6),
              color      : mapFactory.shadeRGBColor(b, -0.3)
            }
          };

          vm.getColorSensor = getColorSensor; //para usarlo desde la vista
          vm.getColorScholander = getColorScholander ; //para usarlo desde la vista

          var getClassColorSensor = function(val, min, max){
            if(val <= min){
              return "red";
            }
            if(val >= max){
              return "green";
            }
            return "yellow";
          }

          var getClassColorScholander = function(val, max){
            if(max == 0){
              return "blue";
            }
            if(val < max - 2){
              return "green";
            }
            if(val >= max){
              return "red";
            }
            return "yellow";
          }


          vm.layerHasData = function(layer) {
            var count = 0;
            angular.forEach(mapaVinedo.data.features, function(feature) {
              if (feature.properties.layer == layer) {
                count ++;
              }
            });
            return count;
          };

          vm.getLayersWithData = function(){
            var layers = {};
            var out = [];
            _.forEach(mapaVinedo.data.features, function(feature) {
              var layer = feature.properties.layer;
              if(layers[layer] == undefined){
                layers[layer] = 0;
              }
              layers[layer] ++;
            });
            _.forEach(layers, function(count, name){
              out.push({
                name: name,
                count:count
              });
            });
            return out;
          }

          var center = {};

          if (mapaVinedo.data === "") {
            console.error("no hay mapa configurado");
          } else {
            this.mapsApi = gma;

            center     = {
              rand      : Math.random(), //HACK para hacer que, al centrar, vea la variable distinta
              latitude  : mapaVinedo.data.properties.center.latitude,
              lat       : mapaVinedo.data.properties.center.latitude,
              longitude : mapaVinedo.data.properties.center.longitude,
              lng       : mapaVinedo.data.properties.center.longitude
            };
            vm.map     = {
              center  : angular.copy(center),
              markers : [],
              zoom    : mapaVinedo.data.properties.zoom
            };
            vm.options = {
              scrollwheel        : true,
              mapTypeId          : google.maps.MapTypeId.HYBRID,
              scaleControl       : true,
              streetViewControl  : false,
              zoomControl        : true,
              zoomControlOptions : {
                position : google.maps.ControlPosition.TOP_RIGHT
              },
              mapTypeControl     : false,
              rotateControl      : false
            };

            vm.centrar = function () {
              $timeout(function () {
                //cambia la variable, para que detecte el evento gmaps
                center.rand       = Math.random();
                vm.options.center = angular.copy(center);
                vm.map.center     = angular.copy(center);
                vm.options.zoom   = mapaVinedo.data.properties.zoom;
                vm.map.zoom       = mapaVinedo.data.properties.zoom;
              });
            };

            var initMap  = function(insMap, setCenter) {
              setCenter = setCenter || false;
              mapFactory.getDataServer(insMap, mapaVinedo.data, setCenter);
              vm.map.markers.splice(0, vm.map.markers.length);

              $timeout(function () {
                insMap.map.data.forEach(function (feature) {
                  if (feature.getProperty('layer') === vm.actualLayer ||
                      (angular.isUndefined(feature.getProperty('layer')) && vm.actualLayer === 'sector')  ) {

                    var labelContent = feature.getProperty('label');
                    var colorTag     = null;

                    if (vm.actualLayer === "scholander") {
                      var sectorScholander = vm.getFeatureData(feature, "scholander");
                      colorTag             = getClassColorScholander(sectorScholander.dato.bares, sectorScholander.dato.limite);
                      labelContent         = feature.getProperty('label') + " <br/><span class='marker-tag " + colorTag + " '> " +
                          sectorScholander.dato.bares +
                          " bar</span>";
                    }

                    if (vm.actualLayer === "sensor") {
                      var sectorSensor = vm.getFeatureData(feature, "sensor");
                      var cant = 0;
                      if(sectorSensor.datoSelected !== undefined){
                        cant = sectorSensor.datoSelected.cantidad
                      }
                      colorTag         = getClassColorSensor(cant, sectorSensor.rango_min, sectorSensor.rango_max);
                      labelContent     = feature.getProperty('label') + " <br/><span class='marker-tag " + colorTag + "' >" + cant+ "%</span>";
                    }

                    var center = mapFactory.getInnerCenter(feature);

                    vm.map.markers.push({
                      id        : Math.random() * 100000,
                      id_layer  : feature.getProperty('id'),
                      latitude  : center.lat,
                      longitude : center.lng,
                      icon      : 'assets/icons/dot_map.png',
                      options   : {
                        labelContent : labelContent,
                        labelClass   : "marker-labels",
                        labelAnchor  : "50 0"
                      },
                      events    : {
                        click: function (event) {
                          if (vm.actualLayer == "cuartel") {
                            $state.go("vinedo.productividad", {cid: event.model.id_layer});
                          }
                          if (vm.actualLayer == "sector") {
                            //$state.go("cuartel.estadisticas", {id: event.model.id_layer});
                            cuartelDialog.showDialog(null, event.model.id_layer);
                          }
                        }
                      }
                    });
                  }
                });
                $(window).resize();
              });


              insMap.map.data.setStyle(function (feature) {

                var color = '';

                switch (feature.getProperty('layer')) {
                  case 'equipo':
                    color = getColorEquipo(feature.getProperty('id'));
                    break;
                  case 'cuartel':
                    color = getColorCuartel(feature.getProperty('id'));
                    break;
                  case 'sector':
                    color = getColorSector(feature.getProperty('id'));
                    break;
                  case 'scholander':
                    var s = vm.getFeatureData(feature, "scholander");
                    color = getColorScholander(s.dato.bares , s.dato.limite);
                    //color = getColorScholander(_.random(1, 15),10);
                    break;
                  case 'sensor':
                    var s = vm.getFeatureData(feature, "sensor");
                    var cantidad = 0;
                    if(s.datoSelected !== undefined){
                      cantidad = s.datoSelected.cantidad || 0;
                    }
                    color = getColorSensor(cantidad, s.rango_min, s.rango_max);
                    break;
                  default:
                    color = getColorSector(feature.getProperty('id'));
                }

                if (feature.getProperty('alert') && !feature.getProperty('alertDisplayed')) {
                  feature.setProperty("alertDisplayed", true);

                  $timeout(function () {
                    delay();
                  }, 600);

                  function delay() { //jshint ignore:line
                    $timeout(function () {
                      feature.setProperty("showAlert", !feature.getProperty("showAlert"));
                      delay();
                    }, 600);
                  }

                }
                if (feature.getProperty('showAlert')) {
                  color = 'red';
                }

                return /** @type {google.maps.Data.StyleOptions} */({
                  fillColor   : color.background,
                  strokeColor : color.border,
                  strokeWeight: 2,
                  fillOpacity : 0.6
                });
              });


              var setPositionWindowsMap = function (latLng) {
                $timeout(function () {
                  vm.windowInfo.latLng  = latLng;
                  vm.windowInfo.visible = true;
                });
              };


              //-------------------------
              //Eventos
              //-------------------------

              // When the user clicks, set 'isColorful', changing the color of the letters.
              insMap.map.data.addListener('click', function (event) {
                // event.feature.setProperty('isColorful', true);
                //TODO poner opciones para otros tipos de layer
                vm.windowInfo.scope = {
                  getColorSensor     : getColorSensor,
                  getClassColorSensor: getClassColorSensor,
                  showDialogSectorRiego : vm.showDialogSectorRiego
                };
                if ((event.feature.getProperty("layer") == "sector" ||
                        event.feature.getProperty("layer") === "" ||
                        event.feature.getProperty("layer") === undefined ) &&
                    vm.getFeatureData(event.feature, "sector") !== null
                ) {
                  var sectorFeature                = vm.getFeatureData(event.feature, "sector");
                  vm.windowInfo.options.visible    = false;
                  vm.windowInfo.scope.title        = event.feature.getProperty("label");
                  vm.windowInfo.scope.etacum       = sectorFeature.et_acumulada;
                  vm.windowInfo.scope.volTemporada = sectorFeature.volumen;
                  vm.windowInfo.scope.reposicion   = sectorFeature.reposicion;
                  setPositionWindowsMap(mapFactory.getInnerCenter(event.feature));//event.feature.getCenterMass());
                  $timeout(function () {
                    vm.windowInfo.options.visible = true;
                  }, 1);
                } else if (event.feature.getProperty("layer") == "sensor" &&
                    vm.getFeatureData(event.feature, "sensor")
                ) {
                  var sectorSensorFeature          = vm.getFeatureData(event.feature, "sensor");
                  vm.windowInfo.options.visible    = false;
                  vm.windowInfo.scope.title        = event.feature.getProperty("label");
                  vm.windowInfo.scope.sectorSensor = sectorSensorFeature;
                  //setPositionWindowsMap(event.feature.getCenterMass());
                  setPositionWindowsMap(mapFactory.getInnerCenter(event.feature));//event.feature.getCenterMass());
                  $timeout(function () {
                    vm.windowInfo.options.visible = true;
                  }, 1);
                } else if (event.feature.getProperty("layer") == "cuartel" &&
                    vm.getFeatureData(event.feature, "cuartel")
                ) {
                  var cuartelFeature               = vm.getFeatureData(event.feature, "cuartel");
                  vm.windowInfo.options.visible    = false;
                  vm.windowInfo.scope.title        = event.feature.getProperty("label");
                  vm.windowInfo.scope.toneladas_ha = cuartelFeature.toneladas_ha;
                  vm.windowInfo.scope.kg_poda_mt   = cuartelFeature.kg_poda_mt;
                  vm.windowInfo.scope.m3_ha        = cuartelFeature.m3_ha;
                  vm.windowInfo.scope.bayas        = cuartelFeature.bayas;
                  vm.windowInfo.scope.ravaz        = cuartelFeature.ravaz;
                  vm.windowInfo.scope.p_reposicion = cuartelFeature.p_reposicion;
                  //setPositionWindowsMap(event.feature.getCenterMass());
                  setPositionWindowsMap(mapFactory.getInnerCenter(event.feature));//event.feature.getCenterMass());
                  $timeout(function () {
                    vm.windowInfo.options.visible = true;
                  }, 1);
                } else {
                  vm.windowInfo.options.visible = false;
                }
              });

              // When the user hovers, tempt them to click by outlining the letters.
              // Call revertStyle() to remove all overrides. This will use the style rules
              // defined in the function passed to setStyle()

              insMap.map.data.addListener('mouseover', function (event) {
                insMap.map.data.revertStyle();
                insMap.map.data.overrideStyle(event.feature, {strokeWeight: 6});
                $timeout(function () {
                  if (vm.actualLayer == "sensor") {
                    vm.sectorSensorOver            = vm.getFeatureData(event.feature, "sensor");
                    var delta                      = vm.sectorSensorOver.rango_max - vm.sectorSensorOver.rango_min;
                    vm.sectorSensorOver.rango_low  = vm.sectorSensorOver.rango_min - delta;
                    vm.sectorSensorOver.rango_high = vm.sectorSensorOver.rango_max + delta;

                    var porcentaje = (100 / (delta * 3)) * (vm.sectorSensorOver.datoSelected.cantidad - vm.sectorSensorOver.rango_low);

                    if (porcentaje < 0) {
                      porcentaje = 0;
                    }

                    if (porcentaje > 100) {
                      porcentaje = 100;
                    }
                    vm.sectorSensorOver.porcentaje = porcentaje;
                    vm.sectorSensorOver.show       = true;

                  }
                });
              });

              insMap.map.data.addListener('mouseout', function (event) {
                insMap.map.data.revertStyle();
                if (angular.isDefined(vm.sectorSensorOver)) {
                  $timeout(function () {
                    vm.sectorSensorOver.show = false;
                  });
                }
              });
            }

            vm.getFeatureData = function (feature, type) {
              switch (type) {
                case "sector":
                  var sectorFeature = null;
                  angular.forEach(sectoresData.data, function (sector) {
                    if (sector.id == feature.getProperty("id")) {
                      sectorFeature = sector;
                    }
                  });
                  return sectorFeature;
                  break;

                case "scholander":
                  var scholanderFeature = null;
                  angular.forEach(vm.sectoresScholander, function (sectorScholander) {
                    if (sectorScholander.nombre== feature.getProperty("label")) {
                      scholanderFeature = sectorScholander;
                    }
                  });
                  if(scholanderFeature === null){
                    //ya que la version anterior del dash no asignaba el nombre de los sectores
                    //con una id, se busca por nombre si no se ha encontrado nada
                    angular.forEach(vm.sectoresScholander, function (sectorScholander) {
                      if (sectorScholander.id == feature.getProperty("id")) {
                        scholanderFeature = sectorScholander;
                      }
                    });
                  }
                  return scholanderFeature;
                  break;

                case "sensor":
                  var sensorFeature = null;
                  angular.forEach(vm.sectoresSensor, function (sensor) {
                    if (sensor.id == feature.getProperty("id")) {
                      sensorFeature = sensor;
                    }
                  });
                  return sensorFeature;
                  break;

                case "cuartel":
                  var cuartelFeature = null;
                  angular.forEach(cuartelesData.data, function (cuartel) {
                    if (cuartel.id == feature.getProperty("id")) {
                      cuartelFeature = cuartel;
                    }
                  });
                  return cuartelFeature;
                  break;
                default:
                  console.error("getFeatureData: type no encontrado");
                  return null;
              }
            };

            vm.changeLayer = function (layer, refresh) {
              refresh = refresh == undefined ? true : refresh;
              mapFactory.setLayer(layer);
              vm.actualLayer = layer;
              if(refresh){
                initMap(vm.insMap, false);
              }
              vm.windowInfo.options.visible = false;
              //}
            };


            var sidebarProm = global.sidebarData;
            var rprom       = ready.promise();

            $q.all([rprom, sidebarProm])
                .then(function (response) {
                  var instances = response[0]; //instanias del mapa, primer promise
                  instances.forEach(function (insMap) {
                    definirColores();
                    var geo = mapaVinedo.data;
                    var layers = vm.getLayersWithData();
                    vm.changeLayer(layers[0].name, false);
                    initMap(insMap, true);
                    vm.insMap = insMap;
                    google.maps.event.trigger(insMap.map, 'resize');
                    vm.centrar();
                  });//instances.forEach(...)
                });//ready.promise()


          }



        }]);

})();
